export default {
  namespaced: true,
  data() {
    return {
      login: '',
      password: '',
      hidePw: true,
      isFormValid: false,
      loginRules: {
        password: v => (v.length && v.length > 5) || 'Укажите пароль',
        phone: v => (v.length && v.length >= 17)
          || 'Номер телефона заполнен не полностью',
        required: v => !!v || 'Поле должно быть заполнено',
      },
      loginModal: false,
    };
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    isBannersOn() {
      return this.$store.state.settings.module_banners === true;
    },
    banners() {
      return this.$store.state.banners.bannersList || [];
    },
    bannersGroup() {
      return this.$store.state.banners.group || null;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    externalLoad() {
      return this.$store.state.settings.external_load === true;
    },
    phoneMask() {
      const masks = {
        russia8: '8 (###) ###-####',
        russia7: '+7 (###) ###-####',
        belarus: '+375 (##) ###-####',
      };

      // eslint-disable-next-line no-unused-vars
      const russia7Regex = /^\+?7/; // Номера РФ начинаются с 7
      const russia8Regex = /^8/; // Номера РФ начинаются с 8
      const belarusRegex = /^\+?37?5?/; // Номера Беларуси начинаются с 375

      if (russia8Regex.test(this.login)) {
        return masks.russia8;
      }
      if (belarusRegex.test(this.login)) {
        return masks.belarus;
      }

      return masks.russia7;
    },
  },
  methods: {
    Login() {
      const app = this;
      app.$store.getters.axl
        .post('api/login', { login: app.login, password: app.password })
        .then((response) => {
          app.$store.dispatch('UserLogin', response.data);
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    loadBannersList() {
      if (!this.externalLoad && !this.isAuthenticated && this.isBannersOn) {
        this.$store.dispatch('banners/GetBannersList');
      }
    },
  },
  watch: {
    externalLoad: {
      deep: true,
      immediate: true,
      handler() {
        this.loadBannersList();
      },
    },
    isAuthenticated: {
      deep: true,
      immediate: true,
      handler() {
        this.loadBannersList();
      },
    },
    isBannersOn: {
      deep: true,
      immediate: true,
      handler() {
        this.loadBannersList();
      },
    },
    '$route.query': function $routeQuery() {
      if (this.$route.query.loginModal) {
        this.loginModal = true;
        this.$router.push('/');
      }
    },
  },
  mounted() {
    if (this.$route.query.loginModal) {
      this.loginModal = true;
      this.$router.push('/');
    }
    this.$store.dispatch('banners/InitialStoreBanners');
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
  },
};
